//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions, mapMutations } from "vuex";
import { date } from "quasar";
import PassModal from "@/components/User/passModal.vue";
import ValidateCode from "@/components/User/ValidateCode.vue";
import defaultUserImage from "@/assets/images/user.svg";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";
import { allowAccessibilityColors, getDynamicEnv } from "@/assets/js/appFunc";

export default {
    name: "MyAccount",
    components: {
        PassModal,
        ValidateCode,
        AQInput,
        AQButton,
        AQDropdown,
        AQToggle,
        AQCheckbox
    },
    data() {
        return {
            editDetails: false,
            enableAccessibility: false,
            localEditedDetails: null,
            localEditedAvatar: null,
            loadingState: false,
            localPassObj: null,
            openPassModal: false,
            noProfileImage: false,
            interfaceSaved: false,
            multiLangEnabled: false,
            isAccessibilityEnabled: false,
            twoFactorEnabled: false,
            showValidationPhone: false,
            phoneError: false,
            phoneEmpty: false,
            twoFactorId: "",
            wrongAccessCode: false,
            expiredAccessCode: false,
            error: {},
            feature: null,
            openModal: false,
            notifyPhone: false,
            notifyPass: false,
            isFromSAML: false,
            language: 0,
            accessibilityFromCall: false,
            accountTab: "settings"
        };
    },
    computed: {
        ...mapGetters("userProfile", [
            "userDataDetails",
            "notificationsSettings",
            "userProfileImage",
            "myRoles"
        ]),
        ...mapGetters("main", ["interfaceDirty"]),
        ...mapGetters("admin", ["featuresByTenant"]),
        isReadOnly() {
            return !this.editDetails || this.isFromSAML || this.isExternalUser;
        },
        isExternalUser() {
            return !!(this.userDataDetails.sourceType === "AD" || this.userDataDetails.type === "TSAMLUSR"
                || this.userDataDetails.type === "TOPENIDUSR" || this.userDataDetails.realmId);
        },
        computedPhoneErr() {
            let err = "";
            if (this.phoneError) {
                err = this.$t("admin.usersAndRoles.manualAddModal.phoneErr");
            } else if (this.phoneEmpty) {
                err = this.$t("userProfile.emptyPhone");
            }
            return err;
        },
        accessibilityInfo() {
            return !this.isAccessibilityEnabled && this.accessibilityFromCall
                ? this.$t("userProfile.allowAdminAccessibility") : this.$t("userProfile.allowAccessibility");
        },
        allowAccessibilityEdit() {
            let isDisabled = true;
            if (!this.checkIfAccessibilityDisabled) {
                isDisabled = !this.editDetails;
            }
            return isDisabled;
        },
        checkIfAccessibilityDisabled() {
            return !this.isAccessibilityEnabled || !this.accessibilityFromCall;
        },
        computedLanguageOptions() {
            const languageOptions = [
                { value: "en", label: this.$t("userProfile.en") },
                { value: "ro", label: this.$t("userProfile.ro") }
            ];
            return languageOptions;
        },
        computedUserProfileImage: {
            get() {
                if (this.editDetails && this.localEditedAvatar) {
                    return this.localEditedAvatar;
                }
                if (this.userProfileImage.length < 50) { // backend method has 33 chars in length, added 50 to be safe, base64 ones are much longer in size
                    return this.userProfileImage.replace(/.$/, "m");
                }
                return this.userProfileImage;
            }
        },
        computedEnableLangChange() {
            let disable = false;
            if (!this.editDetails || !this.multiLangEnabled) {
                disable = true;
            }
            return disable;
        },
        computedUsername() {
            const firstName = this.computedUserDetails.firstName || "";
            const lastName = this.computedUserDetails.lastName || "";

            if (firstName || lastName) {
                return `${firstName} ${lastName}`;
            }

            return this.userDataDetails.email;
        },
        computedOccupation() {
            const position = this.userDataDetails.position || "";
            const department = this.userDataDetails.department || "";
            let occupation;
            if (position && department) {
                occupation = `${department} - ${position}`;
            } else if (position && !department) {
                occupation = position;
            } else if (!position && department) {
                occupation = department;
            }
            return occupation;
        },
        computedUserDetails() {
            this.$store.commit("main/setInterfaceDirty", false);
            return this.localEditedDetails;
        },
        computedPasswordLastUpdate() {
            let modifyDate = this.userDataDetails.passwordLastUpdate || null;

            if (this.editDetails && this.localPassObj) {
                modifyDate = this.localPassObj.modifyDate || modifyDate;
            }

            if (modifyDate) {
                return this.$t("userProfile.lastPasswordUpdateOn", { date: date.formatDate(modifyDate, "DD.MM.YYYY") });
            }
            return this.$t("userProfile.passwordNeverUpdated");
        },
        maxSize() {
            return getDynamicEnv("UPLOAD_LIMIT_USER_AVATAR");
        }
    },
    watch: {
        userDataDetails: {
            deep: true,
            immediate: true,
            handler(v) {
                this.localEditedDetails = {
                    firstName: v.firstName,
                    lastName: v.lastName,
                    colorsAccessibility: v.colorsAccessibility,
                    phone: v.phone,
                    oldPassword: null,
                    newPassword: null,
                    language: v.language,
                    file: null
                };
            }
        },
        localEditedDetails: {
            deep: true,
            handler() {
                if (!this.interfaceSaved) {
                    this.$store.commit("main/setInterfaceDirty", true);
                } else if (this.interfaceSaved && this.localEditedDetails.language) {
                    const lang = this.localEditedDetails.language;
                    this.$i18n.locale = lang;
                    localStorage.setItem("language", lang);
                }
            }
        }
    },
    validations: {
        localEditedDetails: {
            phone: {
                checkPhone() {
                    return this.checkPhone(this.localEditedDetails.phone);
                }
            }
        }
    },
    created() {
        this.getUserDetails();
        this.getNotificationsSettings();
        this.getMyRoles();
    },
    mounted() {
        this.$store.dispatch("main/getMultiFeaturesOption").then(
            data => {
                if (data) {
                    const multiLanguageObj = data.data.find(item => item.code === "ALLOW_MULTILANGUAGE");
                    this.multiLangEnabled = multiLanguageObj.enabled;

                    const hasAccFeature = localStorage.getItem("accessibilityFeature");
                    this.isAccessibilityEnabled = hasAccFeature === "true";

                    const accessibilityProp = data.data.find(item => item.code === "ACCESSIBILITY");
                    this.accessibilityFromCall = accessibilityProp.enabled;
                    this.enableAccessibility = this.userDataDetails.colorsAccessibility;
                }
            }
        );
        this.isFromSAML = JSON.parse(localStorage.getItem("fromSAML"));
    },
    activated() {
        this.interfaceSaved = false;
    },
    methods: {
        ...mapActions("userProfile", [
            "getUserDetails",
            "getNotificationsSettings",
            "getMyRoles"
        ]),
        ...mapActions("admin", ["getFeaturesByTenant", "validateCode"]),
        ...mapMutations("main", ["setInterfaceDirty"]),
        ...mapActions("main", ["getMultiFeaturesOption"]),
        launchFilePicker() {
            this.$refs.file.click();
        },
        editDetailsMode() {
            this.editDetails = true;
            this.interfaceSaved = false;
        },
        previewImage(e) {
            const image = e.target.files[0];
            const allowedFileTypes = ["image/jpg", "image/jpeg", "image/png"];

            if (allowedFileTypes.indexOf(image.type.toLowerCase()) === -1) {
                this.$toast.showNotify({
                    message: this.$t("userProfile.uploadedProfileImageTypeError"),
                    type: "error"
                });
                e.target.value = null;
                return false;
            }
            if (image.size > this.maxSize.bytesSize) {
                this.$toast.showNotify({
                    message: this.$t("userProfile.uploadedProfileImageSizeError", { maxSize: this.maxSize.value }),
                    type: "error"
                });
                e.target.value = null;
                return false;
            }

            this.localEditedDetails.avatar = image;

            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = ev => {
                this.localEditedAvatar = ev.target.result;
            };
            return false;
        },
        checkTwoFactorAuth() {
            this.checkPhone();
            if (!this.phoneError) {
                if (this.feature
                    && this.feature.enabled) {
                    if (!this.phoneEmpty) {
                        if ((this.localEditedDetails.phone !== this.userDataDetails.phone)
                            || (this.localPassObj && this.localPassObj.newPass)
                            || this.openModal) {
                            this.showValidationPhone = true;
                            this.openModal = true;
                            this.saveDetails();
                        } else {
                            this.saveDetails(true);
                        }
                    }
                } else {
                    this.saveDetails(true);
                }
            }
        },
        saveDetails(changeSubmit) {
            this.interfaceSaved = true;
            this.$store.commit("main/setInterfaceDirty", false);
            const formData = new FormData();
            this.loadingState = true;
            this.localEditedDetails.oldPassword = this.localPassObj ? this.localPassObj.oldPass : null;
            this.localEditedDetails.newPassword = this.localPassObj ? this.localPassObj.newPass : null;
            this.localEditedDetails.colorsAccessibility = this.enableAccessibility;
            localStorage.setItem("accessibility", this.enableAccessibility);
            const hasAccFeature = localStorage.getItem("accessibilityFeature");
            allowAccessibilityColors(this.enableAccessibility && hasAccFeature === "true");

            if (this.localEditedDetails.phone !== this.userDataDetails.phone) {
                this.notifyPhone = true;
            }
            if (this.localEditedDetails.newPassword) {
                this.notifyPass = true;
            }
            Object.keys(this.localEditedDetails).forEach(key => {
                if (this.localEditedDetails[key] !== null) {
                    formData.append(key, this.localEditedDetails[key]);
                }
            });
            if (!formData.entries().next().done) {
                const newPass = this.localEditedDetails.newPassword;
                this.$store.dispatch("userProfile/saveUserProfile", { formData, localData: this.localEditedDetails, changeSubmit }).then(data => {
                    this.twoFactorId = data.data;
                    this.afterSavedProfileDetails(changeSubmit);
                    if (newPass && changeSubmit) {
                        window.location.href = "/login";
                    }
                    const lang = this.localEditedDetails.language;
                    this.$i18n.locale = lang;
                    localStorage.setItem("language", lang);
                    localStorage.setItem("changedFlag", true);
                    if (changeSubmit) {
                        this.$root.$emit("renderMenu");
                    }
                    this.language++;
                },
                () => {
                    this.loadingState = false;
                });
            } else {
                this.afterSavedProfileDetails(changeSubmit);
            }
        },

        afterSavedProfileDetails(changeSubmit) {
            this.loadingState = false;
            if (this.localEditedAvatar) {
                this.$store.commit("userProfile/setImg", this.localEditedAvatar);
            }
            if (changeSubmit) {
                this.editDetails = false;
                this.localEditedAvatar = null;
                this.localPassObj = null;
            }
        },
        saveNotifications() {
            this.$store.dispatch("userProfile/saveNotificationsSettings", this.notificationsSettings);
        },
        onProfileImageError(ev) {
            ev.target.src = defaultUserImage;
            this.noProfileImage = true;
        },
        cancelEdit() {
            this.interfaceSaved = true;
            this.localEditedAvatar = null;
            this.localPassObj = null;
            this.editDetails = false;
            this.localEditedDetails.firstName = this.userDataDetails.firstName;
            this.localEditedDetails.language = this.userDataDetails.language;
            this.enableAccessibility = this.localEditedDetails.colorsAccessibility;
            this.language++;
            this.localEditedDetails.lastName = this.userDataDetails.lastName;
            this.localEditedDetails.phone = this.userDataDetails.phone;
            this.localEditedDetails.newPassword = null;
            this.localEditedDetails.oldPassword = null;
            this.localEditedDetails.avatar = null;
            this.phoneError = false;
            this.phoneEmpty = false;
            this.openModal = false;
        },
        cancelPassChanges() {
            this.localPassObj = null;
            this.openPassModal = false;
        },
        checkPhone() {
            this.feature = this.featuresByTenant.find(element => element.code === "ALLOW_TWO_FACTOR");
            if (!this.isFromSAML && !["TSAMLUSR", "TOPENIDUSR"].includes(this.userDataDetails.type)) {
                if (this.localEditedDetails && this.localEditedDetails.phone) {
                    const regex2 = /^[+][0-9]{1,15}$/;
                    this.phoneEmpty = false;
                    this.phoneError = !regex2.test(this.localEditedDetails.phone);
                } else if (this.feature && this.feature.enabled && (!this.userDataDetails.phone || !this.localEditedDetails.phone)) {
                    this.phoneError = false;
                    this.phoneEmpty = true;
                } else {
                    this.phoneError = false;
                }
            }
        },
        openPassModalCheck() {
            this.checkPhone();
            if (!this.phoneError && !this.phoneEmpty) {
                this.openPassModal = true;
            }
        },
        showNotification(message) {
            this.$toast.showNotify({
                type: "success",
                message
            });
        },
        validateAccessCode(accessCode) {
            this.validateCode({ twoFactorId: this.twoFactorId, code: accessCode })
                .then(() => {
                    this.$store.commit("userProfile/updateUserDetails", this.localEditedDetails);
                    this.editDetails = false;
                    this.localEditedAvatar = null;
                    this.localPassObj = null;
                    this.openModal = false;
                    this.error = "";
                    if (this.notifyPass) {
                        this.showNotification(this.$t("userProfile.changePassCode.validPass"));
                    }
                    if (this.notifyPhone) {
                        setTimeout(() => {
                            this.showNotification(this.$t("userProfile.changePassCode.validSuccess"));
                        }, 0);
                    }
                    this.notifyPhone = false;
                    this.notifyPass = false;
                    this.$root.$emit("renderMenu");
                    if (this.localEditedDetails.newPassword) {
                        window.location.href = "/login";
                    }
                })
                .catch((err) => {
                    if (err.response && err.response.data) {
                        this.error = err.response.data;
                    }
                });
        }
    }
};

